import { Response200Type } from 'src/domains/casino/api/generated/providers/openapi_providers_customer_get_session';
import {
    CasinoStoreFetchedCategoriesAndGamesWebsiteModelType,
    CasinoStoreProviderZod,
} from 'src/api_openapi/v2/casino-store/schemas';
import { z } from 'zod';

// main casino types

export type CollectionType = 'casino' | 'live-casino' | 'virtuals';
export type CollectionWithBingoType = CollectionType | 'bingo';

// casino store types

export type CategoriesAndGamesType = CasinoStoreFetchedCategoriesAndGamesWebsiteModelType;
export type CategoryType = CategoriesAndGamesType['categories'][0];
export type GameType = CategoriesAndGamesType['games'][0];

export const ProviderZod = CasinoStoreProviderZod;
export type ProviderType = z.TypeOf<typeof ProviderZod>;

// game session types

export type SessionResponseType =
    | {
          status: 'loading';
      }
    | {
          status: 'ready';
          value: SessionDataType;
      }
    | {
          status: 'error';
          message: string;
      };

export type SessionDataType = Response200Type;

export type SessionConfigType = {
    provider: ProviderType;
    params: SessionParamsType;
};

export interface SessionParamsType {
    gameId: string;
    mode?: 'mini' | 'demo';
    mobile: boolean;
    homeAddress: string;
}
